import { useEffect, useState } from 'react'
import { api, setUnauthorizedHandler } from './api'
import type { Env, User } from './api'
import { Login } from './screens/Login'
import { Owner } from './screens/Owner'
import { Shell } from './screens/Shell'

export function App() {
  const [user, setUser] = useState<User | null>(null)
  const [via, setVia] = useState<'online' | 'offline'>('online')
  const [env, setEnv] = useState<Env | null>(null)
  const [theme, setTheme] = useState<'light' | 'dark'>(
    () => (localStorage.getItem('cscan.theme') === 'dark' ? 'dark' : 'light'),
  )

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    localStorage.setItem('cscan.theme', theme)
  }, [theme])

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null))
    void api.me().then(setUser).catch(() => undefined)
    void api.env().then(setEnv).catch(() => setEnv(null))
  }, [])

  const logout = () => {
    localStorage.removeItem('cscan.token')
    setUser(null)
  }
  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))

  if (!user) return <Login env={env} onLogged={(u, v) => { setUser(u); setVia(v) }} />

  // O dono da nuvem tem um painel só dele: cadastra clínicas, não vê prontuário.
  if (user.role === 'owner') {
    return <Owner user={user} theme={theme} onToggleTheme={toggleTheme} onLogout={logout} />
  }

  return (
    <Shell
      user={user}
      env={env}
      sessionVia={via}
      theme={theme}
      onToggleTheme={toggleTheme}
      onLogout={logout}
    />
  )
}
